export enum UserCrmType {
  Salesforce = 'SALESFORCE',
  Hubspot = 'HUBSPOT',
  SugardCrm = 'SUGARCRM',
  Other = 'OTHER',
  Netsuite = 'NETSUITE',
  Dynamics = 'DYNAMICS',
  Bullhorn = 'BULLHORN',
}
